import styled from 'styled-components'

import { DocumentKind, getDocumentKind } from './document-kind'
import { ReactComponent as PdfIcon } from '../../assets/images/icons/pdf-icon.svg'
import { ReactComponent as DocumentIcon } from '../../assets/images/icons/document.svg'
import {
  DocumentsGalleryThumbnailVariant,
  GalleryThumbnailsProps,
} from './documents-gallery.types'
import { Icon } from '../icon'

const ThumbnailsWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.sizes.xs};
    margin-bottom: ${theme.sizes.m};
  `}
`

const Thumbnail = styled.button<{
  selected: boolean
  variant: DocumentsGalleryThumbnailVariant
}>`
  ${({ theme, selected, variant }) => `
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${theme.colors.primary400};
    border-radius: ${theme.sizes.xs};
    width: ${theme.sizes[16]};
    height: ${theme.sizes[16]};
    
    > img {
      width: ${theme.sizes[16]};
      height: ${theme.sizes[16]};
      object-fit: contain;
      overflow: hidden;
    }

    ${
      variant === 'green' &&
      `border-color: ${theme.colors.success400};
       &:before {
        content: '';
        position: absolute;
        width: ${theme.sizes[3]};
        height: ${theme.sizes[3]};
        background-color: ${theme.colors.success400};
        top: -5px;
        left: 6px;
        border-radius: 50%;
        transition: width .2s ease, height .2s ease;
        }
      `
    };
    ${
      variant === 'warning' &&
      `border-color: ${theme.colors.warning400};
      `
    }
    ${selected && `border-width:2px;`};

    ${
      selected &&
      variant === 'green' &&
      `&:before {
        width: ${theme.sizes[4]};
        height: ${theme.sizes[4]};
        top: -7px;
      }
      `
    }
  `}
`

const DocumentIconWrapper = styled.div`
  display: flex;
  width: 75%;
  height: 75%;

  > svg {
    width: 100%;
    height: 100%;
  }
`

const WarningIconWrapper = styled.div`
  ${({ theme }) => `
    position: absolute;
    top: ${theme.sizes[1]};
    right: ${theme.sizes[1]};
  `}
`

const THUMBNAIL_TEST_ID_PREFIX: Record<DocumentKind, string> = {
  pdf: 'pdf',
  image: 'img',
  other: 'doc',
}

export const GalleryThumbnails = ({
  files,
  selectedFileUrl,
  onThumbnailClick,
}: GalleryThumbnailsProps) => {
  return (
    <ThumbnailsWrapper>
      {files?.map(({ url, variant = 'default' }, index) => {
        const kind = getDocumentKind(url)

        return (
          <Thumbnail
            key={`thumbnail-${url}`}
            selected={url === selectedFileUrl}
            variant={variant}
            onClick={() => onThumbnailClick(url)}
            data-testid={`${THUMBNAIL_TEST_ID_PREFIX[kind]}-thumbnail-${index}`}
          >
            {kind === 'image' && <img src={url} alt={`${index} thumbnail`} />}
            {kind === 'pdf' && <PdfIcon />}
            {kind === 'other' && (
              <DocumentIconWrapper>
                <DocumentIcon />
              </DocumentIconWrapper>
            )}
            {variant === 'warning' && (
              <WarningIconWrapper data-testid="gallery-warning-icon">
                <Icon name="warning" size={5} color="warning400" />
              </WarningIconWrapper>
            )}
          </Thumbnail>
        )
      })}
    </ThumbnailsWrapper>
  )
}
